<template>

  <div>
    <h4 v-if="title">{{ title }}</h4>
    <v-layout align-center>
      <v-flex xs6>
        <v-radio-group
          :input-value="value"
          @change="onTypeChange"
        >
          <v-radio
            v-for="item in types"
            :key="item"
            :label="item"
            :value="item"
          ></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
export default {
  name: "SettingsSwitching",
  props: {
    title: {
      type: String,
      default: ''
    },
    types: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    onTypeChange (ev) {
      this.$emit('input', ev)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleSettingsFormComponents/SettingsSwitching.vue